import React from 'react';
import SingleSelectComboBox, { SingleSelectComboBoxProps } from '../AbstractComboBox/SingleSelectComboBox';
import { TopContentResult } from '../AbstractComboBox/types/SuggestResultTypes';
import { useHtmlValidId } from '../../../../../../hooks/useHtmlValidId';
import getContentTopResults from './getContentTopResult';
import ListItemPage from '../AbstractComboBox/ListItemPage/ListItemPage';

type ContentSingleSelectComboBoxProps = SingleSelectComboBoxProps & {
  onChange?: (item?: TopContentResult) => void;
};

export function ContentSingleSelectComboBoxForForm2(props: Omit<ContentSingleSelectComboBoxProps, 'id' | 'name'>) {
  const id = useHtmlValidId();
  return (
    <SingleSelectComboBox
      {...props}
      id={`content-single-select-combobox-${id}`}
      name={undefined}
      responseMapper={getContentTopResults}
      inputValueSelector={item => item.title}
    >
      {item => <ListItemPage page={item} />}
    </SingleSelectComboBox>
  );
}
